import { axiosInstance } from '.'
import {
  NEED_HELP_WITH_OPPORTUNITY_INVESTMENT,
  OPPORTUNITIES_PAGE_WHATSAPP_MESSAGE,
  REQUEST_CALLBACK_MESSAGE,
  SECONDARY_MARKET_SUPPORT_MESSAGE,
  SECONDARY_MARKET_TRADE_SUPPORT_MESSAGE_PREFIX,
} from '../lib/utils/message'
import { CREDIBILA_SUPPORT_PHONE_NUMBER } from '../utils/constants'
import { POST_OPPORTUNITY_WHATSAPP, WHATS_APP_SUPPORT } from './endpoints'

const openWhatsApp = (text: string) => {
  const message = encodeURIComponent(text)
  window.open(`https://wa.me/${CREDIBILA_SUPPORT_PHONE_NUMBER}?text=${message}`, '_blank')
}

export const whatsAppService = {
  requestStartSupport: async (headers: { [key: string]: string }) => {
    try {
      return await axiosInstance.get(WHATS_APP_SUPPORT, {
        headers: headers,
      })
    } catch (error: any) {
      return error.response
    }
  },

  requestOpportunityWhatsApp: async (opportunityId: number) => {
    try {
      return await axiosInstance.post(POST_OPPORTUNITY_WHATSAPP(opportunityId), {})
    } catch (error: any) {
      return error.response
    }
  },

  requestCallback: () => {
    openWhatsApp(REQUEST_CALLBACK_MESSAGE)
  },

  requestInvestmentSupport: (opportunityName: string) => {
    openWhatsApp(`${NEED_HELP_WITH_OPPORTUNITY_INVESTMENT} ${opportunityName}`)
  },

  requestOpportunitiesPageSupport: () => {
    openWhatsApp(OPPORTUNITIES_PAGE_WHATSAPP_MESSAGE)
  },

  requestSecondaryMarketSupport: () => {
    openWhatsApp(SECONDARY_MARKET_SUPPORT_MESSAGE)
  },

  requestSecondaryMarketTradeSupport: (orderId: string, opportunityTitle?: string | null) => {
    const opportunityPart = opportunityTitle ? ` Opportunity: ${opportunityTitle}.` : ''
    openWhatsApp(
      `${SECONDARY_MARKET_TRADE_SUPPORT_MESSAGE_PREFIX} ${orderId}.${opportunityPart} Please assist.`,
    )
  },
}
